export enum AppRoutesEnum {
    DASHBOARDS = '/dashboard',
    LOGIN = '/login',
    EMPTY = '',
    TRIAGED_ALERTS = '/alerts-triaged',
    INVESTIGATIONS = '/investigations',
    THREAT_HUNTS = '/threat-hunts',
    RESPONSE_ACTIONS = '/response-actions',
    CUSTOMER_VERIFICATION_REQUESTS = '/customer-verification-requests',
    RECOMMENDATIONS = '/recommendations',
    TICKETS = '/support-tickets',
    REPORTS = '/reports',
    EMERGENCY_CONTACT = '/emergency-contacts',
    PRE_APPROVED_ACTIONS = '/pre-approved-actions',
    USERS = '/users',
    COMPANIES = '/companies',
    ONBORADING_ISSUES = '/companies-onboarding-issues',
    MONITORING_ISSUES = '/companies-monitoring-issues',
    OFFBOARDING_LIST = '/companies-offboarding-list',
    ONBOARDING_HISTORY = '/companies-onboarding-history',
    DOCUMENTS = '/documents',
    CQ_CST = '/cq/browse',
    CQ_ADMIN = '/cq/questionnaire',
    BREACH_WARRANTY = '/breach-warranty',
    TERMS_AND_CONDITIONS = '/terms-and-conditions',
    MAINTENANCE = '/maintenance',
}
